import styled from 'styled-components';
import { MdAccessTime } from 'react-icons/md';

const DisabledEntryRemarkWrapper = styled.div`
  font-size: 0.8rem;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  line-height: 1.3;
`;

const IconWrapper = styled.span`
  flex-shrink: 0;
  margin-right: 8px;
  display: flex;
  align-items: center;
`;

const DisabledEntryRemark = ({ entries }) => {
  const hasCustom = entries && entries.some((entry) => entry.type === 'custom');
  const hasNoDef = entries && entries.some((entry) => entry.type != 'custom' && !entry.hasDef);
  if (!hasCustom && !hasNoDef) return null;

  let message = '';
  if (hasCustom && !hasNoDef) {
    message = 'Support for custom phrases is coming soon.';
  } else if (!hasCustom && hasNoDef) {
    message = 'Some words in your list don’t have definitions yet. We’re working to add more soon!';
  } else if (hasCustom && hasNoDef) {
    message = 'Support for custom phrases and more definitions is coming soon.';
  }

  return (
    <DisabledEntryRemarkWrapper>
      <IconWrapper>
        <MdAccessTime size={16} color='rgb(142, 61, 255)' />
      </IconWrapper>
      <span>{message}</span>
    </DisabledEntryRemarkWrapper>
  );
};

export default DisabledEntryRemark;
